import {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import DataTable from "@/components/DataTable";

import FileUploadIcon from "@mui/icons-material/FileUpload";

import {GpsAPI} from "@/api/gps";
import {setMatchTab} from "@/actions";
import {ERROR_OPERATION} from "@/utils/constants";
import {GPS_FILE_IMPORT} from "@/utils/gpsSessions";

// Gare della stagione con dati GPS: il dettaglio è nel tab Carico della gara
function GPSSessionsPage(props) {
	const {handleNotification} = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const seasonId = useSelector((state) => state?.season?.id);

	const [sessions, setSessions] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;
		const fetchSessions = async () => {
			setLoading(true);
			try {
				const rows = seasonId ? await GpsAPI.sessions({seasonId}) : [];
				if (active) setSessions(rows || []);
			} catch {
				if (active) handleNotification(ERROR_OPERATION, "error");
			} finally {
				if (active) setLoading(false);
			}
		};
		fetchSessions();
		return () => {
			active = false;
		};
	}, [seasonId]);

	const columns = [
		{
			key: "date",
			label: "Data",
			render: (row) => moment(row.date).format("DD/MM/YYYY"),
			sortValue: (row) => row.date,
		},
		{
			key: "match",
			label: "Gara",
			render: (row) => row.homeTeam + " - " + row.awayTeam,
		},
		{
			key: "playersCount",
			label: "Giocatori",
			align: "end",
			sortable: true,
		},
	];

	const mainActions = GPS_FILE_IMPORT
		? [
				{
					icon: <FileUploadIcon />,
					title: "Importa da file",
					onClick: () => navigate("/gps/import"),
				},
			]
		: [];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="GPS"
				actions={<MainActions actions={mainActions} />}
			/>
			<VLFCard
				title="Gare con dati GPS"
				content={
					<DataTable
						columns={columns}
						rows={sessions.map((s) => ({...s, id: s.matchId}))}
						onRowClick={(row) => {
							dispatch(setMatchTab("gps"));
							navigate("/matches/" + row.matchId);
						}}
						empty="Nessuna gara con dati GPS in questa stagione. Si inseriscono dalla gara, nel tab Carico."
					/>
				}
			/>
		</Page>
	);
}

export default GPSSessionsPage;
